import React from "react";
import { Link } from "react-router-dom";

const ProactiveDisclouser = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Proactive Disclouser</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <p>
          <strong>U/S 4 (1)(a) of RTI Act</strong>
        </p>

        <p>
          HSDC has initiated the process of computerizing the records and
          displaying it on its website www.haryanaseeds.org.in for easy access
          of information to the general public. The scope of the information
          displayed on website shall be improved gradually. Information about
          various activities and services, applicable Acts/ Rules, tenders/
          advertisements issued from time to time, standardized documents for
          various services, circulars etc. is available on website.
        </p>

        <p>
          <strong>U/S 4 (1)(b) of RTI Act</strong>
        </p>
        <ol>
          <li>
            {" "}
            <Link
              to={"/rti/proactive-disclouser/particulars-of-organization"}
              className="text-decoration-none"
            >
              Particulars of Organization, Functions &amp; Duties
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/powers-duties"} className="text-decoration-none">
              Powers &amp; Duties of its Officer &amp; Employees
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/procedure-followed"} className="text-decoration-none">
              Procedure followed in the Decision Making Process
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/norms"} className="text-decoration-none">
              Norms set for discharge of functions
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/rules-regulations-instructions"}
              className="text-decoration-none"
            >
              The Rules, Regulations, Instructions, Manuals &amp; Record
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/statement-of-categories"}
              className="text-decoration-none"
            >
              Statement of Categories of Documents
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/particulars-of-any-arrangement"}
              className="text-decoration-none"
            >
              The Particulars of any arrangement that exists for consultation
              with or representation by the member of public in relation to the
              formulation of its policy or implementation thereof
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/statements"} className="text-decoration-none">
              Statement of the boards, councils, committees &amp; other bodies
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/directory-of-officers-employees"}
              className="text-decoration-none"
            >
              A Directory of Officers &amp; Employees
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/monthly-remuneration"} className="text-decoration-none">
              The Monthly Remuneration received by each of its officers and
              employees
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/budget-allotment"} className="text-decoration-none">
              Budget Allotment
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/manner-of-execution"} className="text-decoration-none">
              The manner of execution of subsidy programme
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/particulars-of-recipients"}
              className="text-decoration-none"
            >
              Particulars of recipients of concessions, permits or authorization
              granted by it
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/details-in-respect-of-information-available"}
              className="text-decoration-none"
            >
              Details in respect of information available to or held by it in an
              electronic form
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/particulars-of-facilities"}
              className="text-decoration-none"
            >
              The Particulars of facilities available to citizens for obtaining
              information
            </Link>
          </li><hr/>
          <li>
            <Link
              to={"/rti/proactive-disclouser/public-information-officers"}
              className="text-decoration-none"
            >
              The Names, Designations &amp; other particulars of Public
              Information Officers
            </Link>
          </li><hr/>
          <li>
            <Link to={"/rti/proactive-disclouser/faqs"} className="text-decoration-none">
              Such Other Information / FAQs
            </Link>
          </li><hr/>
        </ol>
      </div>
    </div>
  );
};

export default ProactiveDisclouser;
